import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Tone } from '../../Shape2/Shape2';

import './SidebarMenu.css';
import * as keyset from './SidebarMenu.i18n';

const i18n = i18nFactory(keyset);

export interface SidebarMenuProps {
    secondLevelMenuContent?: React.ReactNode;
    thirdLevelMenuContent?: React.ReactNode;
    items?: SidebarMenuItems;
    expanded?: boolean;
    onExpandClick: () => void;
}

export interface SidebarMenuItem {
    id: string;
    selected?: boolean;
    onClick?: () => void;
    icon: Shape2Icon;
    title: string;
}

export interface SidebarMenuItems {
    static: SidebarMenuItem[];
    dynamic: SidebarMenuItem[];
}

interface SidebarMenuState {
    wasExpanded: boolean;
}

const block = 'sidebar-menu';

export class SidebarMenu extends React.Component<SidebarMenuProps, SidebarMenuState> {
    constructor(props: SidebarMenuProps) {
        super(props);

        this.state = {
            wasExpanded: false
        };
    }

    componentDidUpdate(prevProps: SidebarMenuProps) {
        if (prevProps.expanded !== this.props.expanded) {
            this.setState({
                wasExpanded: this.state.wasExpanded || Boolean(this.props.expanded)
            });
        }
    }

    render() {
        const { expanded, onExpandClick, items } = this.props;
        const { wasExpanded } = this.state;

        return (
            <div
                className={Bem.cls({
                    block,
                    mods: {
                        expanded: Boolean(expanded),
                        'was-expanded': wasExpanded
                    }
                })}
            >
                <div
                    className={Bem.cls({
                        block,
                        elem: 'primary-wrapper'
                    })}
                >
                    <div className={Bem.cls(block, 'primary-menu-wrapper')}>
                        <div className={Bem.cls(block, 'primary-menu')}>
                            <div
                                className={Bem.cls({
                                    block,
                                    elem: 'primary-menu',
                                    mods: { static: true }
                                })}
                            >
                                {items && this.getPrimaryItems(items.static)}
                            </div>
                            {items && items.dynamic.length > 0 && (
                                <div
                                    className={Bem.cls({
                                        block,
                                        elem: 'primary-menu',
                                        mods: { dynamic: true }
                                    })}
                                >
                                    {this.getPrimaryItems(items.dynamic)}
                                </div>
                            )}
                        </div>
                        <div
                            className={Bem.cls(block, 'primary-item', {
                                'expand-item': true
                            })}
                            onClick={onExpandClick}
                            title={expanded ? i18n('collapse') : i18n('expand')}
                        >
                            <Shape2
                                cls={Bem.cls(block, 'expand')}
                                width={20}
                                height={20}
                                icon={Shape2Icon.verticalArrow}
                                tone={Shape2Tone.grey}
                            />

                            <span className={Bem.cls(block, 'primary-item-title')}>{i18n('collapse')}</span>
                        </div>
                    </div>
                </div>
                {this.getSecondLevelMenu()}
            </div>
        );
    }

    private getPrimaryItems(items: SidebarMenuItem[] = []) {
        return (
            <>
                {items.map((el: SidebarMenuItem, index) => {
                    return (
                        <div
                            key={index}
                            className={Bem.cls(block, 'primary-item', {
                                id: el.id,
                                selected: Boolean(el.selected)
                            })}
                            onClick={el.onClick}
                            title={el.title}
                        >
                            <Shape2 width={20} height={20} icon={el.icon} tone={Shape2Tone.grey} />

                            <span className={Bem.cls(block, 'primary-item-title')}>{el.title}</span>
                        </div>
                    );
                })}
            </>
        );
    }

    private getSecondLevelMenu() {
        const { secondLevelMenuContent } = this.props;

        if (!secondLevelMenuContent) {
            return null;
        }

        return (
            <div
                className={Bem.cls(block, 'second-level-menu', {
                    level: 'first '
                })}
            >
                <div className={Bem.cls(block, 'second-level-menu_content')}>{secondLevelMenuContent}</div>
                {this.getThirdLevelMenu()}
            </div>
        );
    }

    private getThirdLevelMenu() {
        const { thirdLevelMenuContent } = this.props;

        if (!thirdLevelMenuContent) {
            return null;
        }

        return (
            <div
                className={Bem.cls(block, 'third-level-menu', {
                    level: 'second'
                })}
            >
                {thirdLevelMenuContent}
            </div>
        );
    }
}
